import React, { useState } from "react";
import { Modal, Input, Select, Button, Row, Col, message } from "antd";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { IconButton } from "@mui/material";
import styled from "@emotion/styled";
import { URL } from "../../../helper/Mainurl";
const { Option } = Select;

const StyledModalWrapper = styled.div`
  position: relative;
`;

const Title = styled.h2`
  font-size: 20px;
  color: #333;
  margin-bottom: 24px;
`;

const StyledButton = styled(Button)`
  width: 100%;
  height: 48px;
  font-size: 16px;
  background-color: #a855f7;
  border: none;
  color: white;
  border-radius: 5px;
  margin-top:6px;

  &:hover {
    background-color: #9333ea;
  }
`;

const ModalContent = styled.div`
  padding: 16px;
  background: white;
  border-radius: 16px;
`;

  const OutsideCloseButton = styled.div`
    position: absolute;
    top: -48px;
    right: -22px;
    background: white;
    border-radius: 50%;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    width: 22px;
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 1000;
  `;

const StyledSelect = styled(Select)`
  .ant-select-arrow {
    color: #666;
  }
`;

const InviteLinkBox = styled.div`
  margin-top: 24px;
  background: #f9f9f9;
  padding: 12px 16px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #eee;
`;

const InviteLink = styled.span`
  color: #a855f7;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const InviteModal = ({ open, onClose }) => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [role, setRole] = useState(null);
  const [inviteLink, setInviteLink] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedAccess, setSelectedAccess] = useState("view"); // Null by default


  const getPermissionId = (access) => {
    const map = {
      full: 3,
      view: 4,
      limited: 5,
      edit: 6
    };
    return map[access] || 4; // Default to 'view' if not selected
  };

  const handleInvite = async () => {
    if (!email ) {
      return message.warning("Please fill out name and email.");
    }
    const permissionId = getPermissionId(selectedAccess);

    try {
      setLoading(true);
      const token = localStorage.getItem("authToken");
      const response = await fetch(`${URL}/v1/invite/link`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, // Add token if needed
        },
        body: JSON.stringify({
          email,
          feature: role || "member",
          // permission_id : permissionId
        }),
      });

      const data = await response.json();
      if (data.code === 200) {
        setInviteLink(data.data.invite_link);
        message.success("Invite link generated!");
      } else {
        message.error(data.message  || "Failed to generate invite link.");
      }
    } catch (err) {
      console.error("err",err);
      message.error(err.response.data.message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(inviteLink).then(() => {
      message.success("Copied to clipboard!");
    });
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      closable={false}
      centered
      width={700}
      bodyStyle={{ padding: 0 }}
    >
      <StyledModalWrapper>
        <ModalContent>
          <OutsideCloseButton onClick={onClose}>
            <CloseIcon fontSize="medium" />
          </OutsideCloseButton>

          <Title>Invite</Title>

          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Input
                placeholder="Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </Col>
            <Col span={12}>
              <Input
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Col>

            {/* <Col span={12}>
              <StyledSelect
                placeholder="Role"
                style={{ width: "100%" }}
                value={role}
                onChange={(value) => setRole(value)}
                getPopupContainer={(trigger) => trigger.parentNode}
                suffixIcon={<KeyboardArrowDownIcon />}
              >
                <Option value="admin">Admin</Option>
                <Option value="member">Member</Option>
              </StyledSelect>
            </Col>

            <Col span={12}>
               <StyledSelect
                 placeholder="Access"
                 style={{ width: "100%" }}
                 getPopupContainer={(trigger) => trigger.parentNode}
                 suffixIcon={<KeyboardArrowDownIcon />}
               >
                 <Option value="full">Full</Option>
                 <Option value="limited">Limited</Option>
               </StyledSelect>

              <SelectLabel>Access</SelectLabel>
              <StyledSelect
                defaultValue="view"
                placeholder="Select Access"
                style={{ width: "100%" }}
                onChange={(value) => setSelectedAccess(value)}
                suffixIcon={<KeyboardArrowDownIcon />}
              >
                <Option value="limited">Limited</Option>
                <Option value="view">View Only</Option>
                <Option value="edit">Edit</Option>
                <Option value="full">Full Access</Option>
              </StyledSelect>
             </Col>


             <Col span={12}>
              <StyledSelect
                placeholder="Select Batch"
                style={{ width: "100%" }}
                getPopupContainer={(trigger) => trigger.parentNode}
                suffixIcon={<KeyboardArrowDownIcon />}
              >
                <Option value="batch1">Batch 1</Option>
                <Option value="batch2">Batch 2</Option>
              </StyledSelect>
            </Col>

            <Col span={12}>
              <StyledSelect
                placeholder="Add another batch"
                style={{ width: "100%" }}
                getPopupContainer={(trigger) => trigger.parentNode}
                suffixIcon={<KeyboardArrowDownIcon />}
              >
                <Option value="batch3">Batch 3</Option>
                <Option value="batch4">Batch 4</Option>
              </StyledSelect>
            </Col> */}

            {/* Optional: Add your other selects here */}

            <Col span={24}>
              <StyledButton loading={loading} onClick={handleInvite}>
                 Add
              </StyledButton>
            </Col>
          </Row>

          {inviteLink && (
            <InviteLinkBox>
              <InviteLink>{inviteLink}</InviteLink>
              <IconButton onClick={handleCopy} style={{ color: "#a855f7" }}>
                <ContentCopyIcon />
              </IconButton>
            </InviteLinkBox>
          )}
        </ModalContent>
      </StyledModalWrapper>
    </Modal>
  );
};

export default InviteModal;

